/**
 * Converts an array of objects into a map of and id prop to the object.
 * @template T The type of each element in the array
 * @param {T[]} items The array of objects to map.
 * @param {string} prop The property to use as the id, defaults to 'id'.
 * @returns {Object.<string, T>} The id mapped objects.
 */
export function idMap(items, prop = 'id') {
    return items.reduce((map, item) => ({
        ...map,
        [item[prop]] : item
    }), {});
}


export function toArray(hash) {
    return Object.keys(hash).map((key)=>hash[key]);
}



// WEBPACK FOOTER //
// ./src/util/idMap.js